import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from './login/login.component';
import {ForgotPaswordComponent} from './forgot-password/forgot-password.component';
import { AuthorizationErrorComponent } from './authorization-error/authorization-error.component';
import { ResetPaswordComponent } from './forgot-password/reset-password.component';
import { OTPVerifyComponent } from './otp-verify/otp-verify.component';
import { LinkExpiredComponent } from './link-expired/link-expired.component';



const routes: Routes = [
  { path: 'auth', component: LoginComponent },
  { path: 'forgot-password', component: ForgotPaswordComponent },
  { path: 'auth-error', component: AuthorizationErrorComponent},
  { path: 'reset/:token', component: ResetPaswordComponent},
  { path: 'otp-verify/:email', component: OTPVerifyComponent},
  { path: 'otp-verify', component: OTPVerifyComponent},
  { path: 'link-expired', component: LinkExpiredComponent },

];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AuthRoutingModule { }
